import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';

export default function BreederProfileMoreAboutBreederItemsSkeleton() {
  return (
    <div className="BreederProfileMoreAboutBreederItemsSkeleton flex flex-column gap-40 font-16 md:font-18">
      <SkeletonBlock height="6em" />
      <SkeletonBlock height="6em" />
      <SkeletonBlock height="3em" />
      <SkeletonBlock height="4em" />
      <SkeletonBlock height="4em" />
    </div>
  );
}
